import React, {useState} from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import {buttonType, imageType} from '../../../utils/commonPropTypes'
import {NoInteractiveButton} from '../../../components/Button'
import WidthContainer from '../../../components/WidthContainer'
import {QueriedGatsbyImage} from '../../../components/GatsbyImage'
import {useHighlightOverlay} from '../../../components/HighlightOverlay'

const RootContainer = styled(WidthContainer)`
	margin-top: 5.6rem;
`

const Title = styled.h1`
	font-size: ${props => props.theme.fontSizes.big30};
`

const MockedImages = styled.div`
	margin: 3.68rem 0;

	> div {
		display: flex;
		margin: -1rem;
		
		> div {
			margin: 1rem;
			flex: 1;
		}
	}
`

const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`

const ImageContainer = styled.div`
	flex: 1;
	display: flex;
	cursor: pointer;
	
	> * {
		flex: 1;
	}
`

function chunkArray(array, chunkSize) {
	const result = []
	for (let i = 0; i < array.length; i += chunkSize) {
		result.push(array.slice(i, i + chunkSize))
	}
	return result
}

function MomentsSection({className, data}) {
	const [displayRest, setDisplayRest] = useState(false)
	const topRow = data.items.slice(0, 2)
	const bottomRow = data.items.slice(2, 5)
	const rest = data.items.slice(5)

	const {showOverlay} = useHighlightOverlay()
	const collection = data.items.map(({big, youtubeUrl}) => youtubeUrl ? {youtubeUrl} : big)

	const showImage = (index) => {
		showOverlay({collection, visibleIndex: index})
	}


	return <RootContainer className={className}>
		<Title>{data.title}</Title>
		<MockedImages>
			<div style={{height: '33.1rem'}}>
				{topRow.map((one, i) => <ImageContainer key={one.small.src} onClick={() => showImage(i)}>
					<QueriedGatsbyImage image={one.small}/>
				</ImageContainer>)}
			</div>
			<div style={{height: '21.1rem'}}>
				{bottomRow.map((one, i) => <ImageContainer key={one.small.src} onClick={() => showImage(i + 2)}>
					<QueriedGatsbyImage image={one.small}/>
				</ImageContainer>)}
			</div>
			{displayRest && chunkArray(rest, 3).map((chunk, chunkI) => <div key={chunkI} style={{height: '21.1rem'}}>
				{chunk.map((one, i) => <ImageContainer
					key={one.small.src}
					onClick={() => showImage(5 + chunkI * 3 + i)}>
					<QueriedGatsbyImage image={one.small}/>
				</ImageContainer>)}
			</div>)}
		</MockedImages>
		<ButtonContainer>
			{!displayRest && <NoInteractiveButton
				onClick={() => setDisplayRest(true)}
				inverted>{data.button.label}</NoInteractiveButton>}
		</ButtonContainer>
	</RootContainer>
}


MomentsSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
			title: PropTypes.string.isRequired,
			button: buttonType.isRequired,
			items: PropTypes.arrayOf(PropTypes.oneOf([
				PropTypes.shape({
					small: imageType.isRequired,
					big: imageType.isRequired,
				}),
				PropTypes.shape({
					youtubeUrl: PropTypes.string.isRequired,
					small: imageType.isRequired,
				}),
			]).isRequired).isRequired,
		},
	).isRequired,
}

MomentsSection.defaultProps = {
	className: '',
}

export default MomentsSection
